import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const AbcFmsAnalysis = {
	name: NAME,
	apiProvider,
	router,
};
